export default "__VITE_ASSET__DYJZEBpi__"